import { Flex, Grid, Link, Text } from "@chakra-ui/react";
import * as React from "react";
import { DataGridItem, HeadingGridItem } from "../../index";
import { Fragment } from "react";
import { MdLaunch } from "react-icons/md";
import { Card } from "../../../../../components/Card";

function ClimatePolicyRadarPolicies({ data, source }) {
  return (
    <Card>
      <Grid templateColumns="repeat(13, 1fr)" border={"1px solid lightgray"} borderRadius="md">
        <HeadingGridItem colSpan={4} text={"Name"} />
        <HeadingGridItem colSpan={8} text={"Description"} />
        <HeadingGridItem colSpan={1} text={""} />

        {data.map(el => {
          return (
            <Fragment key={el.name}>
              <DataGridItem colSpan={4} fontSize="md" fontWeight="bold"
                            children={el.name} alignItems="start" />
              <DataGridItem colSpan={8} fontSize="md" children={el.description} />
              <DataGridItem isText={false} justifyContent={"center"}
                            children={el.link && el.link !== "" && el.link.toLowerCase() !== "n/a" ?
                              <Link
                                href={el.link}
                                isExternal>
                                <MdLaunch />
                              </Link> : null} />
            </Fragment>
          );
        })}
      </Grid>
      {source && source !== "" &&
        <Flex marginTop="5" gap={2} alignItems="center" justifyContent="center">
          <Text>Source:</Text>
          <Link
            color={"esg_blue"}
            textDecoration="underline"
            isExternal
            href={source}>
            {source}
          </Link>
        </Flex>
      }
    </Card>
  );
}

export default ClimatePolicyRadarPolicies;